import React, { useState } from 'react';
import {
  Container,
  Box,
  Button,
  Menu,
  MenuItem,
  AppBar,
  Toolbar,
  styled,
  Typography
} from '@mui/material';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useResetReduxState } from 'hooks/common-hooks';

// Styled components
const StyledNavLink = styled(NavLink)<{ isactive: string }>(({ isactive }) => ({
  textDecoration: 'none',
  color: isactive === 'true' ? '#fff' : '#333',
  padding: '8px 16px',
  borderRadius: '4px',
  transition: 'all 0.2s ease-in-out',
  backgroundColor: isactive === 'true' ? '#2b8818' : 'transparent',
  fontWeight: isactive === 'true' ? 500 : 400,
  '&:hover': {
    backgroundColor: '#2b8818',
    color: '#fff',
  },
}));


const StyledButton = styled(Button)<{ isactive: string }>(({ isactive }) => ({
  color: isactive === 'true' ? '#fff' : '#333',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  textTransform: 'none',
  lineHeight: 'inherit',
  padding: '8px 16px',
  backgroundColor: isactive === 'true' ? '#2b8818' : 'transparent',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: '#2b8818',
    color: '#fff'
  },
}));

const NavContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '3px',
  gap: '8px', // Spacing between dashboard and settings
});

interface SettingsMenuItem {
  label: string;
  path: string;
}

const settingsMenuItems: SettingsMenuItem[] = [
  { label: 'User Role Map', path: '/config/user/list' },
  { label: 'Raw Data', path: '/config/rawdata' }
];

export const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const resetReduxState = useResetReduxState();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const userContext = useAppSelector((state) => state.userContextDetails.data);
const userRole = useAppSelector((state) =>  state.userContextDetails?.data[0]?.role.toLowerCase());
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (path: string) => {
    navigate(path);
    handleClose();
  };

  const handelNewLeaseCreation = () =>{
    resetReduxState()
    navigate('/lease/form/new')
  }
  const isAdmin = userContext[0]?.role === "Admin";

  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={1}
      sx={{ width: '100%'}}
    >
      <Container maxWidth={false} >
        <NavContainer>
          <StyledNavLink to="/lease"
            isactive={(location.pathname === '/lease').toString()}>
            Dashboard
          </StyledNavLink>

          {isAdmin && (
            <>
              <StyledButton
                variant="text"
                aria-controls={open ? 'settings-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
                isactive={(location.pathname === '/config/user/list' || location.pathname === '/config/rawdata/home').toString()}
              >
                Settings
              </StyledButton>

              <Menu
                id="settings-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'settings-button',
                }}
                sx={{
                  '& .MuiPaper-root': {
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    minWidth: '200px',
                    marginTop: '8px',
                    
                  }
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                {settingsMenuItems.map((item) => (
                  <MenuItem
                    key={item.label}
                    onClick={() => handleMenuItemClick(item.path)}
                    sx={{
                      padding: '12px 24px',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <Typography variant="body2">
                      {item.label}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
          {(!(userRole === "accenture" || userRole === "asset manager" ||userRole === "accounting" || userRole === "analyst") && !location.pathname.includes('/form/new') &&
          <Button
            variant="contained"
            onClick={() => handelNewLeaseCreation()}
            className="new-lease-btn"
          >
            <AddIcon sx={{ fontSize: "1rem", marginRight: "2.5px", marginLeft: "-4px" }} /> New Lease
          </Button>)}
        </NavContainer>
      </Container>
    </AppBar>
  );
};
